import React from "react"
import Moment from "moment"
import { withFormik } from "formik"
import * as Yup from "yup"
import RequiredStar from "components/common/RequiredStar"
import ClientInvoiceStatusConstants from "constants/ClientInvoiceStatusConstants"

import {
    Container,
    Col,
    Form,
    FormGroup,
    Label,
    Row,
    Button,
    Input
} from "reactstrap"

const BaseForm = props => {
    const {
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
    } = props

    return (
        <div>
            <Form noValidate onSubmit={handleSubmit}>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <RequiredStar />
                                <Label for="invoiceAmount">Invoice Issued Date</Label>
                                <Input
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.dateIssued}
                                    type="date"
                                    name="dateIssued"
                                    id="dateIssued"
                                    placeholder="Issued Date"
                                    invalid={errors.dateIssued} />
                                {errors.dateIssued && <small className="text-danger">{errors.dateIssued}</small>}
                            </FormGroup>
                        </Col>
                    </Row>
                </Container>
                <Button outline className="float-right" disabled={isSubmitting} color="success" type="submit">Publish</Button>
            </Form>
        </div>
    )
}

const validationSchema = Yup.object({
    dateIssued: Yup.date()
        .required("Invoice issued date is required")
        .typeError("Must be a date")
})

const ClientInvoicePublishForm = withFormik({
    displayName: "ClientInvoicePublishForm",
    validationSchema: validationSchema,
    enableReinitialize: true,
    mapPropsToValues: ({ ...props }) => ({
        ...props
    }),
    handleSubmit: (values, { props, setSubmitting }) => {
        values.status = ClientInvoiceStatusConstants.UNPAID;
        props.onSubmitUpdate(values);
        setSubmitting(false)
    }
})(BaseForm)

export default ClientInvoicePublishForm